import { AddCustomerAddressInput } from "../customer-address";
import { AddCustomerEmployeeInput } from "../customer-employee";

export class AddCustomerInput {
    public code: string = '';
    public name: string = '';
    public taxNumber: string = '';
    public logoFile = '';
    public logoFileName = '';
    public taxAdministration: string = '';
    public addCustomerProjects: Array<number> = [];
    public addCustomerCargoIntegrations: Array<number> = [];
    public addCustomerERPs: Array<number> = [];
    public addCustomerModules: Array<number> = [];
    public addCustomerVirtualPoses: Array<number> = [];
    public addEmployees: Array<AddCustomerEmployeeInput> = [];
    public addCustomerAddresses: Array<AddCustomerAddressInput> = [];
}
